/**
 * Opens a URL in a new popup window.
 * This is a wrapper around window.open to allow for easier testing and mocking.
 * 
 * TODO: Stub this in tests to prevent real windows from opening during test runs.
 * 
 * @param url The URL to open.
 * @returns boolean - true if the popup was successfully opened, false otherwise.
 */
export const openIntent = (url: string): boolean => {
  const popup = window.open(url, '_blank');
  if (!popup || popup.closed || typeof popup.closed === 'undefined') {
    return false; // Popup was blocked or failed to open.
  }
  return true; // Popup opened successfully.
}; 